<div class="page-container">
    <header class="page-header">
        <div class="header-left">
            <h1>Projects</h1>
            <p class="subtitle">Manage projects and their status</p>
        </div>
        <button (click)="openCreateModal()" class="btn-primary">
            <i class="fa fa-plus"></i> New Project
        </button>
    </header>

    <div *ngIf="errorMessage" class="error-alert">
        {{ errorMessage }}
    </div>

    <div *ngIf="isLoading && projects.length === 0" class="loading-state">
        <div class="spinner"></div>
        <p>Loading projects...</p>
    </div>

    <div *ngIf="!isLoading && projects.length === 0" class="empty-state">
        <p>No projects found. Create your first project!</p>
    </div>

    <div *ngIf="projects.length > 0" class="table-container">
        <table class="premium-table">
            <thead>
                <tr>
                    <th>Project Name</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let project of projects">
                    <td data-label="Project Name"><strong>{{ project.name }}</strong></td>
                    <td data-label="Description" class="description-cell">{{ project.description || 'No description' }}
                    </td>
                    <td data-label="Status">
                        <span class="status-badge status-{{project.status}}">
                            {{ getStatusLabel(project.status) }}
                        </span>
                    </td>
                    <td data-label="Actions">
                        <div class="action-buttons">
                            <button (click)="openEditModal(project)" class="btn-icon" title="Edit">
                                <i class="fa fa-pencil"></i>
                            </button>
                            <button (click)="deleteProject(project.id)" class="btn-icon btn-danger" title="Delete">
                                <i class="fa fa-trash"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<!-- Create/Edit Modal -->
<div *ngIf="showModal" class="modal-overlay" (click)="closeModal()">
    <div class="modal-card" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3>{{ isEditMode ? 'Edit Project' : 'Create New Project' }}</h3>
            <button (click)="closeModal()" class="close-btn">
                <i class="fa fa-times"></i>
            </button>
        </div>

        <form [formGroup]="projectForm" (ngSubmit)="onSubmit()">
            <div class="modal-body">
                <div class="form-group">
                    <label for="name">Project Name *</label>
                    <input id="name" type="text" formControlName="name" placeholder="Enter project name"
                        [class.invalid]="projectForm.get('name')?.invalid && projectForm.get('name')?.touched">
                </div>

                <div class="form-group">
                    <label for="description">Description</label>
                    <textarea id="description" formControlName="description" placeholder="Enter project description"
                        rows="4"></textarea>
                </div>

                <div class="form-group">
                    <label for="status">Status</label>
                    <select id="status" formControlName="status">
                        <option [value]="1">Active</option>
                        <option [value]="2">Completed</option>
                        <option [value]="3">Archived</option>
                    </select>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" (click)="closeModal()" class="btn-secondary">Cancel</button>
                <button type="submit" [disabled]="projectForm.invalid || isLoading" class="btn-primary">
                    {{ isEditMode ? 'Update' : 'Create' }} Project
                </button>
            </div>
        </form>
    </div>
</div>